import request from "../helpers/request";
import { AuthHeader, getUserToken } from "../helpers";
import jwtDecode from "jwt-decode";

export {
  getDashboardPerPatient,
  getDashboardPerDepartment,
  getDashboardPerWasteType,
  getDashboardPerMealCategory,
  getDashboardPerPeriod,
  getDashboardSpreadWeekdays,
  getDashboardPerMealCategoryPerPatient,
};

function checkPrefix() {
  const token = getUserToken();
  let user = "";
  if (token) user = jwtDecode(token);
  let prefix = "";
  if (user.user_type == 1) prefix = "customer/";
  return prefix;
}

function getDashboardPerPatient(location_id, startdate, enddate, filter) {
  const prefix = checkPrefix();
  startdate = parseTime(startdate);
  enddate = parseTime(enddate);

  console.log(startdate);
  console.log(enddate);

  if (prefix !== "") location_id = "";
  else location_id = "/" + location_id;
  return request({
    url: `dashboard/${prefix}per_patient${location_id}?startdate=${startdate}&enddate=${enddate}&filter=${filter}`,
    method: "GET",
    headers: AuthHeader(),
  }).then((res) => {
    return res;
  });
}

function getDashboardPerDepartment(location_id, startdate, enddate, filter) {
  const prefix = checkPrefix();
  startdate = parseTime(startdate);
  enddate = parseTime(enddate);
  if (prefix !== "") location_id = "";
  else location_id = "/" + location_id;
  return request({
    url: `dashboard/${prefix}per_department${location_id}?startdate=${startdate}&enddate=${enddate}&filter=${filter}`,
    method: "GET",
    headers: AuthHeader(),
  }).then((res) => {
    return res;
  });
}

function getDashboardPerWasteType(location_id, startdate, enddate, filter) {
  const prefix = checkPrefix();
  startdate = parseTime(startdate);
  enddate = parseTime(enddate);
  if (prefix !== "") location_id = "";
  else location_id = "/" + location_id;
  return request({
    url: `dashboard/${prefix}per_waste_type${location_id}?startdate=${startdate}&enddate=${enddate}&filter=${filter}`,
    method: "GET",
    headers: AuthHeader(),
  }).then((res) => {
    return res;
  });
}

function getDashboardPerMealCategory(location_id, startdate, enddate, departmentId = 0, filter) {
  const prefix = checkPrefix();
  startdate = parseTime(startdate);
  enddate = parseTime(enddate);
  if (prefix !== "") location_id = "";
  else location_id = "/" + location_id;
  return request({
    url: `dashboard/${prefix}per_meal_category${location_id}?startdate=${startdate}&enddate=${enddate}&department=${departmentId}&filter=${filter}`,
    method: "GET",
    headers: AuthHeader(),
  }).then((res) => {
    return res;
  });
}

function getDashboardPerMealCategoryPerPatient(
  location_id,
  startdate,
  enddate,
  departmentId = 0,
  filter
) {
  const prefix = checkPrefix();
  startdate = parseTime(startdate);
  enddate = parseTime(enddate);
  if (prefix !== "") location_id = "";
  else location_id = "/" + location_id;
  return request({
    url: `dashboard/${prefix}per_meal_category_per_patient${location_id}?startdate=${startdate}&enddate=${enddate}&department=${departmentId}&filter=${filter}`,
    method: "GET",
    headers: AuthHeader(),
  }).then((res) => {
    return res;
  });
}

function getDashboardPerPeriod(location_id, startdate, enddate, filter) {
  const prefix = checkPrefix();
  startdate = parseTime(startdate);
  enddate = parseTime(enddate);
  if (prefix !== "") location_id = "";
  else location_id = "/" + location_id;
  return request({
    url: `dashboard/${prefix}per_period${location_id}?startdate=${startdate}&enddate=${enddate}&filter=${filter}`,
    method: "GET",
    headers: AuthHeader(),
  }).then((res) => {
    return res;
  });
}

function getDashboardSpreadWeekdays(location_id, startdate, enddate, filter) {
  const prefix = checkPrefix();
  startdate = parseTime(startdate);
  enddate = parseTime(enddate);
  if (prefix !== "") location_id = "";
  else location_id = "/" + location_id;
  return request({
    url: `dashboard/${prefix}spread_weekdays${location_id}?startdate=${startdate}&enddate=${enddate}&filter=${filter}`,
    method: "GET",
    headers: AuthHeader(),
  }).then((res) => {
    return res;
  });
}

function parseTime(date) {
  const olddate = new Date(date);
  console.log(olddate);
  const newDate = new Date(olddate.setHours(12));
  return parseInt(newDate.getTime() / 1000).toFixed(0);
}
